// Please only use this file for heavily copy/pasted css, not shared styles between components

export const ellipsisJss = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
